<div class="fui-layout-container">
  <fui-layout-header [breadcrumbs]="breadcrumbs" [headingText]="'events.upcoming_events' | translate" [description]="'events.events_description' | translate">
    <div class="fui-nav-pills m-t-30">
      <ul>
        <li>
          <button [class.active]="viewMode === 'grid' || viewMode === 'list'" (click)="switchView('grid')">{{ "events.events" | translate }}</button>
        </li>
        <li>
          <button [class.active]="viewMode === 'calendar'" (click)="switchView('calendar')">{{ "events.calendar" | translate }}</button>
        </li>
      </ul>
    </div>
  </fui-layout-header>

  @if (viewMode !== "calendar") {
    <hr />
    <div class="fui-layout-pad-content">
      <fui-content-filter [showSidebarToggle]="false" [showSearchInput]="false" [resultsCount]="events.length" (sortChanged)="sortEvents()"></fui-content-filter>
    </div>
    <hr />
  }

  @if (viewMode !== "calendar") {
    @if (loading) {
      <myp-skeleton-loader type="product-tile" height="250px" [number]="6" class="grid-container pad-10"></myp-skeleton-loader>
    }

    @if (!loading && events.length === 0) {
      <div class="fui-layout-pad-content">
        <div class="m-y-50">
          <fui-heading [text]="'events.no_upcoming_events' | translate" fontSize="f7" level="2"></fui-heading>
          <p class="m-t-20">{{ "events.check_back_soon" | translate }}</p>
        </div>
      </div>
    }
    <div class="fui-layout-pad-content">
      <fui-upcoming-live-event></fui-upcoming-live-event>
    </div>
    @if (!loading && events.length > 0 && appService.prefersGrid) {
      <div class="fui-layout-edge-content">
        @for (group of groupedEvents; track group.label) {
          <div class="fui-layout-pad-content m-t-30">
            <fui-heading [text]="group.label" level="3" fontSize="f6"></fui-heading>
          </div>
          <ul class="grid-container widest pad-10 m-t-10">
            @for (event of group.events; track event) {
              <li class="workspace-grid-item" tabindex="0" (click)="goToEvent(event)" (keyup.enter)="goToEvent(event)">
                <div class="position-relative h-full">
                  @if (event.image_url) {
                    <img [src]="event.image_url" />
                  }
                  <div class="d-flex flex-column justify-content-end h-full position-relative">
                    <div class="name">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="detail-container">
                          <fui-heading [text]="event.title" level="2" fontSize="f6" extraClasses="bold creator-title t-20"></fui-heading>
                          <span class="created">{{ event._formattedDate }}</span>
                        </div>
                        <fa-icon icon="chevron-right"></fa-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            }
          </ul>
        }
      </div>
    }

    @if (!loading && events.length > 0 && !appService.prefersGrid) {
      <div class="fui-layout-pad-content">
        @for (group of groupedEvents; track group.label) {
          <div class="m-t-30">
            <fui-heading [text]="group.label" level="3" fontSize="f6"></fui-heading>
          </div>
          <div class="list-container pad-10 m-t-10">
            @for (event of group.events; track event) {
              <myp-list-item
                [title]="event.title"
                [subData]="[event._formattedDate]"
                [showImage]="!!event.image_url"
                [photo]="event.image_url"
                [imageRound]="false"
                [largeImage]="true"
                marginBottom="10px"
                [description]="event.description"
                (itemClicked)="goToEvent(event)"
              ></myp-list-item>
            }
          </div>
        }
      </div>
    }
  }

  @if (viewMode === "calendar") {
    <div class="fui-layout-pad-content">
      @if (loading) {
        <myp-inline-loader [loading]="loading" height="200px" spinnerName="events-calendar-loader"></myp-inline-loader>
      }
      @if (!loading) {
        <fui-calendar [options]="calendarOptions"></fui-calendar>
      }
    </div>
  }

  <div class="m-t-100 p-b-50">
    <fui-footer></fui-footer>
  </div>
</div>
